import { connect } from 'react-redux';
import { setCurrentPage } from '../../../actions';
import CardsListPageNumbers from './CardsListPageNumbers';

const mapStateToProps = (state) => {
  const {
    app: {
      listing: { currentPage, totalPages, totalItems },
    },
  } = state;

  return {
    currentPage,
    totalPages,
    totalItems,
  };
};

export default connect(mapStateToProps, {
  setCurrentPage,
})(CardsListPageNumbers);
